import { Navigate } from "react-router-dom";
import userStore from "../../store/user.store";
import { FC } from "react";

export const ProtectedRoute:FC<any> = ({ children }) => {
  const { user } = userStore();
  if (!user) {
    return <Navigate to="/login" />;
  }
  return children;
};